// Typelizer digest f385051ba6b6354b350668a1743d523c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** DELETE /c/:company_id/payments/:payment_id/cash_transfer */
  destroy: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/cash_transfer', params, options),
    method: 'delete',
  }),

  /** POST /c/:company_id/payments/:payment_id/cash_transfer */
  create: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/cash_transfer', params, options),
    method: 'post',
  }),
}
